/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'add_cash_discount': 'Skonto gewähren',
    'add_discount': 'Rabatt hinzufügen',
    'add_entry': 'Eintrag hinzufügen',
    'add_full_payment': 'Zahlung über offenen Rechnungsbetrag',
    'add_item_as_template': 'Artikel als Vorlage speichern',
    'add_item_to_invoice': 'Zur Rechnung hinzufügen',
    'add_payment': 'Zahlung erfassen',
    'address_required': 'Bitte füge eine Adresse hinzu',
    'amount': 'Betrag',
    'cancel_invoice': 'Rechnung stornieren',
    'cancel_invoice_dialog_body': 'Soll die Rechnung wirklich storniert werden? Es wird automatisch eine Stornorechnung erstellt.',
    'cancel_invoice_dialog_heading': 'Rechnung stornieren?',
    'cancel_invoice_title': 'Stornorechnung',
    'canceled': 'Storniert',
    'capture_imported_invoice': 'Rechnung importieren',
    'cash_discount': 'Skonto',
    'cash_discount_dialog_content': 'Bitte gib den Prozentsatz ein, der als Skonto hinzugefügt werden soll.',
    'cash_discount_dialog_header': 'Skonto hinzufügen',
    'cash_discount_payment_until': 'bei Zahlung bis',
    'cash_discount_payment_until_label': '{cashDiscount} bei Zahlung bis {cashDiscountLimit}',
    'commit': 'Festschreiben',
    'confirm_checked_invoices_delete_body': 'Möchtest du die ausgewählten Rechnungen wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!',
    'confirm_checked_invoices_delete_title': 'Ausgewählte Rechnungen löschen?',
    'confirm_commit_invoice_body': 'Möchtest du die Rechnung wirklich festschreiben? Die Rechnung kann anschließend nicht mehr bearbeitet werden.',
    'confirm_commit_invoice_title': 'Rechnung festschreiben',
    'confirm_invoice_delete_body': 'Möchtest du die Rechnung "{invoice}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!',
    'confirm_invoice_delete_title': 'Rechnung löschen?',
    'copy_invoice': 'Rechnung kopieren',
    'create_invoice': 'Rechnung erstellen',
    'create_template': 'Vorlage anlegen',
    'currency': 'Währung',
    'delete_cash_discount': 'Skonto löschen',
    'delete_discount': 'Rabatt löschen',
    'delivery_date': 'Lieferdatum',
    'delivery_period': 'Lieferzeitraum',
    'description': 'Beschreibung',
    'difference_reason': 'Grund für Differenz zum Rechnungsbetrag',
    'difference_reason_cash_discount': 'Skonto',
    'difference_reason_currency_conversion': 'Gewinn/Verlust durch Währungsumrechnung',
    'difference_reason_partial': 'Teilzahlung',
    'discount': 'Rabatt',
    'discount_added': 'Ein {type} Rabatt von {value} wurde hinzugefügt',
    'discount_deleted': 'Rabatt wurde gelöscht',
    'discount_dialog_content': 'Bitte gib den Betrag ein, der als Rabatt hinzugefügt werden soll.',
    'discount_dialog_header': 'Rabatt hinzufügen',
    'discount_relative': 'Rabatt (relativ)',
    'discount_type': 'Rabattart',
    'download_invoice': 'Rechnung als PDF Datei herunterladen',
    'draft': 'Entwurf',
    'draft_pdf_deny': 'Rechnungen im Entwurfsstatus können nicht heruntergeladen werden',
    'due': '{dueIn} fällig',
    'due_date': 'Fällig bis',
    'due_in': '{dueIn} fällig',
    'end_date': 'Enddatum',
    'export_format': 'Exportformat',
    'export_format_question': 'In welchem Format sollen die Rechnungen exportiert werden?',
    'imported_invoice': 'Rechnungsimport',
    'invalid_discount_value': 'Bitte gib einen gültigen Rabattwert ein',
    'invoice': 'Rechnung | Rechnungen',
    'invoice_address': 'Rechnungsadresse',
    'invoice_amount': 'Rechnungsbetrag',
    'invoice_block_add': 'Gruppe hinzufügen',
    'invoice_block_delete_confirm': 'Möchtest du diese Gruppe wirklich löschen?',
    'invoice_block_heading': 'Gruppenüberschrift',
    'invoice_canceled': 'Rechnung storniert',
    'invoice_committed': 'Die Rechnung wurde festgeschrieben und kann nicht mehr bearbeitet werden',
    'invoice_created': 'Rechnung erstellt',
    'invoice_created_by': 'Rechnung erstellt von',
    'invoice_date': 'Rechnungsdatum',
    'invoice_date_past': 'Das Rechnungsdatum liegt in der Vergangenheit. Soll die Rechnung trotzdem gespeichert werden?',
    'invoice_deleted': 'Rechnung erfolgreich gelöscht | Rechnungen erfolgreich gelöscht',
    'invoice_draft_saved': 'Rechnung wurde als Entwurf gespeichert',
    'invoice_export_modal_body': 'Die Rechnungen können mit den untenstehenden Optionen gefiltert werden. Sollen alle Rechnungen exportiert werden,<br>klicke einfach auf "Exportieren".',
    'invoice_export_modal_title': 'Rechnungen exportieren',
    'invoice_filter_end_date': 'Rechnungsdatum bis',
    'invoice_filter_start_date': 'Rechnungsdatum von',
    'invoice_filter_user_id': 'Erstellt von',
    'invoice_imported_success': 'Rechnung erstellt',
    'invoice_mail_default': 'Sehr geehrter Kunde / sehr geehrte Kundin,  \r\nIm Anhang finden Sie Ihre aktuelle Rechnung über {invoiceTotal} im PDF-Format.  \r\nZum Ansehen und Ausdrucken der Rechnung wird ein PDF-Reader benötigt.  \r\n  \r\nMit freundlichen Grüßen  \r\nIhr {teamName} Team',
    'invoice_meta': 'Rechnungsinformationen',
    'invoice_number': 'Rechnungsnummer',
    'invoice_number_format': 'Rechnungsnummer Format',
    'invoice_number_tooltip': 'Klicken für manuelle Eingabe',
    'invoice_saved': 'Rechnung gespeichert',
    'invoice_send_modal_successful_body': 'Die Rechnung wurde an {address} versendet und sollte bald ankommen.',
    'invoice_send_modal_title': 'Rechnung versenden',
    'invoice_status': 'Rechnungsstatus',
    'invoice_text_template_deleted': 'Textvorlage wurde gelöscht',
    'invoice_title': 'Rechnungstitel',
    'invoices_empty': 'Keine Rechnungen vorhanden',
    'invoices_empty_create': 'Erstelle eine Rechnung indem du auf den untenstehenden Button drückst',
    'item_entry': 'Artikel',
    'item_required': 'Füge bitte mindestens einen Artikel hinzu',
    'mark_open': 'Als offen markieren',
    'mark_paid': 'Als bezahlt markieren',
    'next_invoice_number': 'Fortlaufende Rechnungsnummer',
    'next_quote_number': 'Fortlaufende Angebotsnummer',
    'no_action_available': 'Keine Aktion möglich',
    'no_pending_invoice_import_to_capture': 'Alle Rechnungen importiert',
    'no_templates': 'Keine Vorlagen wurden angelegt',
    'note_bottom': 'Unterer Textbereich',
    'note_top': 'Oberer Textbereich',
    'open': 'Offen',
    'or_use_template': 'oder Vorlage verwenden',
    'original': 'Original',
    'overdue': 'Überfällig',
    'paid': 'Bezahlt',
    'paid_cash_discount': 'Bezahlt',
    'paid_on': 'Gezahlt {paidOn}',
    'partial': 'Teilweise bezahlt',
    'payment_date': 'Datum der Zahlung',
    'payment_deleted': 'Bezahlung wurde gelöscht',
    'payment_modal_added_payment': 'Zahlung von {value} wurde hinzugefügt',
    'payment_modal_title': 'Zahlung hinzufügen',
    'payment_set_as_paid': 'Rechnung wurde als bezahlt markiert',
    'payment_type': 'Art der Zahlung',
    'payments_empty': 'Bisher wurde keine Zahlung registriert',
    'quote_date': 'Datum',
    'quote_number': 'Angebotsnummer',
    'quote_number_format': 'Angebotsnummer Format',
    'recurring': 'Periodisch',
    'reopen_invoice_body': 'Um den Status der Rechnung auf "Offen" zu ändern, müssen alle erfassten Zahlungen gelöscht werden. Sollen die Zahlungen gelöscht und der Status geändert werden?',
    'reopen_invoice_title': 'Status ändern',
    'save_draft': 'Entwurf speichern',
    'send_as_mail': 'Als E-Mail verschicken',
    'start_date': 'Startdatum',
    'storno': 'Stornorechnung',
    'sum_gross': 'Summe (brutto)',
    'sum_net': 'Summe (netto)',
    'text_template_bottom': 'Vorlage unten | Vorlagen unten',
    'text_template_delete_confirm': 'Textvorlage wirklich löschen?',
    'text_template_modal_title': 'Textvorlage nutzen',
    'text_template_saved': 'Textvorlage gespeichert',
    'text_template_top': 'Vorlage oben | Vorlagen oben',
    'use_template': 'Vorlage nutzen',
    'vat': 'Umsatzsteuer',
    'vat_reduction': 'Vom 01.07.2020 bis zum 31.12.2020 galt in Deutschland ein reduzierter USt.-Satz von 16 % statt 19 % bzw. 5 % statt 7 %. Mindestens ein Posten wurde mit 16 % oder 5 % USt angegeben. Soll die Rechnung trotzdem gespeichert werden?'
  },

  /* english */
  en: {
    'add_cash_discount': 'Grant Cash Discount',
    'add_discount': 'Add Discount',
    'add_entry': 'Add entry',
    'add_full_payment': 'Full due amount',
    'add_item_as_template': 'Save article as template',
    'add_item_to_invoice': 'Add to invoice',
    'add_payment': 'Add payment',
    'address_required': 'Please add an address',
    'amount': 'Amount',
    'cancel_invoice': 'Cancel invoice',
    'cancel_invoice_dialog_body': 'Do you really want to cancel the invoice? We will automatically create a cancellation invoice for you.',
    'cancel_invoice_dialog_heading': 'Cancel invoice?',
    'cancel_invoice_title': 'Cancellation invoice',
    'canceled': 'Canceled',
    'capture_imported_invoice': 'Import Invoice',
    'cash_discount': 'Cash Discount',
    'cash_discount_dialog_content': 'Please add the percentage that should be used for a cash discount.',
    'cash_discount_dialog_header': 'Add cash discount',
    'cash_discount_payment_until': 'for payment until',
    'cash_discount_payment_until_label': '{cashDiscount} for payment until {cashDiscountLimit}',
    'commit': 'Commit',
    'confirm_checked_invoices_delete_body': 'Do you really want to delete the selected invoices? This can not be undone!',
    'confirm_checked_invoices_delete_title': 'Delete selected invoices?',
    'confirm_commit_invoice_body': 'Do you really want to commit this invoice? You can no longer edit invoices once they are committed.',
    'confirm_commit_invoice_title': 'Commit Invoice',
    'confirm_invoice_delete_body': 'Do you really want to delete the invoice "{invoice}"? This can not be undone!',
    'confirm_invoice_delete_title': 'Delete invoice?',
    'copy_invoice': 'Copy invoice',
    'create_cancel_invoice_dialog_body': 'The invoice was cancelled. Do you want to create a cancellation invoice?',
    'create_cancel_invoice_dialog_heading': 'Create cancellation invoice?',
    'create_invoice': 'Create Invoice',
    'create_template': 'Create template',
    'currency': 'Currency',
    'delete_cash_discount': 'Delete cash discount',
    'delete_discount': 'Delete discount',
    'delivery_date': 'Delivery date',
    'delivery_period': 'Delivery period',
    'description': 'Description',
    'difference_reason': 'Reason for difference to invoice sum',
    'difference_reason_cash_discount': 'Cash Discount',
    'difference_reason_currency_conversion': 'Profit/Loss from Currency Conversion',
    'difference_reason_partial': 'Partial Payment',
    'discount': 'Discount',
    'discount_added': 'Added a {type} discount of {value}',
    'discount_deleted': 'Discount deleted',
    'discount_dialog_content': 'Please add the amount that should be used for a discount.',
    'discount_dialog_header': 'Add discount',
    'discount_relative': 'Discount (relative)',
    'discount_type': 'Discount type',
    'download_invoice': 'Download invoice as PDF',
    'draft': 'Draft',
    'draft_pdf_deny': 'Draft-Invoices can not be downloaded',
    'due': 'Due {dueIn}',
    'due_date': 'Due date',
    'due_in': 'Due {dueIn}',
    'end_date': 'End date',
    'export_format': 'Export format',
    'export_format_question': 'In which format should the invoices be exported?',
    'imported_invoice': 'Invoice Import',
    'invalid_discount_value': 'Please enter a valid discount value',
    'invoice': 'Invoice | Invoices',
    'invoice_address': 'Invoice address',
    'invoice_amount': 'Invocie Amount',
    'invoice_block_add': 'Add Item Group',
    'invoice_block_delete_confirm': 'Do you really want to delete this group?',
    'invoice_block_heading': 'Group Heading',
    'invoice_canceled': 'Invoice canceled',
    'invoice_committed': 'This invoice has been committed and can no longer be edited',
    'invoice_created': 'Invoice created',
    'invoice_created_by': 'Invoice created by',
    'invoice_date': 'Invoice date',
    'invoice_date_past': 'The invoice date is in the past. Should the invoice still be saved?',
    'invoice_deleted': 'Invoice deleted | Invoices deleted',
    'invoice_draft_saved': 'Invoice is saved as a draft',
    'invoice_export_modal_body': 'You can filter the export if you wish. If you like to export all invoices,<br>just click "Export".',
    'invoice_export_modal_title': 'Export Invoices',
    'invoice_filter_end_date': 'Invoice date from',
    'invoice_filter_start_date': 'Invoice date to',
    'invoice_filter_user_id': 'Created by',
    'invoice_imported_success': 'Invoice created',
    'invoice_mail_default': 'Dear customer,  \r\nattached you find your recent invoice of {invoiceTotal} as PDF.  \r\nTo view and print your invoice you need a PDF-Reader.  \r\n  \r\nSincerely yours  \r\n{teamName} team.',
    'invoice_meta': 'Invoice details',
    'invoice_number': 'Invoice number',
    'invoice_number_format': 'Invoice Number Format',
    'invoice_number_tooltip': 'Click for manual entry',
    'invoice_saved': 'Invoice saved',
    'invoice_send_modal_successful_body': 'The invoice has been sent to {address} and should arrive soon.',
    'invoice_send_modal_title': 'Send invoice',
    'invoice_status': 'Invoice status',
    'invoice_text_template_deleted': 'Text template has been deleted',
    'invoice_title': 'Invoice title',
    'invoices_empty': 'No Invoices',
    'invoices_empty_create': 'Create an invoice by clicking the button below',
    'invoices_export_successful_body': 'We will send you an e-mail with the exported invoices as soon as the export is completed',
    'item_entry': 'Item',
    'item_required': 'Please add at least one item',
    'mark_open': 'Mark as open',
    'mark_paid': 'Mark as paid',
    'next_invoice_number': 'Consecutive Invoice Number',
    'next_quote_number': 'Consecutive Quote Number',
    'no_action_available': 'No Action available',
    'no_pending_invoice_import_to_capture': 'All invoices imported',
    'no_templates': 'No templates stored',
    'note_bottom': 'Bottom textarea',
    'note_top': 'Top textarea',
    'open': 'Open',
    'or_use_template': 'or use template',
    'original': 'Original',
    'overdue': 'Overdue',
    'paid': 'Paid',
    'paid_cash_discount': 'Paid',
    'paid_on': 'Paid {paidOn}',
    'partial': 'Partially Paid',
    'payment_date': 'Payment date',
    'payment_deleted': 'Payment got deleted',
    'payment_modal_added_payment': 'Added payment of {value}',
    'payment_modal_title': 'Add payment',
    'payment_set_as_paid': 'Invoice marked as paid',
    'payment_type': 'Payment type',
    'payments_empty': 'No payment has been tracked yet',
    'quote_date': 'Date',
    'quote_number': 'Quote Number',
    'quote_number_format': 'Quote Number Format',
    'recurring': 'Recurring',
    'reopen_invoice_body': 'To change the invoice status to "Open", all tracked payments have to be removed. Should the payment be removed and the status changed?',
    'reopen_invoice_title': 'Change Status',
    'save_draft': 'Save as draft',
    'send_as_mail': 'Send as email',
    'start_date': 'Start date',
    'storno': 'Cancellation Invoice',
    'sum_gross': 'Sum (gross)',
    'sum_net': 'Sum (net)',
    'text_template_bottom': 'Template bottom | Templates bottom',
    'text_template_delete_confirm': 'Do you really want to delete the text template?',
    'text_template_modal_title': 'Use text template',
    'text_template_saved': 'Text template saved',
    'text_template_top': 'Template top | Templates top',
    'use_template': 'Load template',
    'vat': 'VAT',
    'vat_reduction': 'From 01.07.2020 to 31.12.2020 a reduced VAT rate of 16 % instead of 19 % or 5 % instead of 7 % applied in Germany. There is at least one item with 16 % or 5 % VAT. Should the invoice still be saved?'
  }
}
